import React, { useState, useCallback, useRef, useEffect } from 'react';
import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

const FilterTable = ({ data, update }) => {
  const [searchString, setSearchString] = useState('');
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const filterData = useCallback((string, dataToFilter) => {
    if (!string) {
      return dataToFilter;
    }

    const normalizedString = string.trim().toLowerCase();
    
    return dataToFilter.filter((item) => {
      const dialogFlowId = (item.dialog_flow_id || '').toLowerCase();
      const centribotProjectId = (item.centribot_project_id || '').toLowerCase();
      
      return dialogFlowId.includes(normalizedString) || 
             centribotProjectId.includes(normalizedString);
    });
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchString(value);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      const filtered = filterData(value, data);
      update(0, filtered);
    }, 300);
  };

  return (
    <div className="cen-filter">
      <TextField
        className="cen-filter-input"
        style={{ margin: 8, fontSize: 24, maxWidth: 400, width: '100%' }}
        placeholder="Filter by Dialog Flow ID or Project ID"
        margin="normal"
        onChange={handleSearchChange}
        value={searchString}
        fullWidth
        inputProps={{
          'aria-label': 'Filter table by Dialog Flow ID or Project ID',
          maxLength: 100
        }}
      />
    </div>
  );
};

FilterTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      dialog_flow_id: PropTypes.string,
      centribot_project_id: PropTypes.string,
    })
  ).isRequired,
  update: PropTypes.func.isRequired,
};

export default FilterTable;